import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import EirButton from '../eir-button/EirButton';
import Title from '../title/Title';

class EirPrequalContainer extends Component {
  

  render() {
    
    const imageUrl = window.innerWidth >= 650 ? this.props.backgroundImageDesktop : this.props.backgroundImageMobile;
    const imgStyle = {
      backgroundImage: `url(${imageUrl})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover"
    };


    return (
        
      <Container className="pb-2 pt-1" fluid={true} style={ imgStyle}>
        <Row className="pb-2 pt-3 pr-4 pl-4 justify-content-center align-items-center text-center">
          <Title
            title={this.props.title}
            titleHeight={this.props.titleHeight} 
            fluid={this.props.fluid} 
            useH1={this.props.useH1}
          />
        </Row>
        {/* PWD-197 - clear existing prequal results on click of Generic prequal link */}
        <Row className="pb-3 justify-content-center align-items-center text-center generic-prequal-link">
          {this.props.cta &&
            <EirButton {...this.props.cta} />
          }
        </Row>
          
      </Container>
    );
  }
}

export default EirPrequalContainer;